import { X } from "lucide-react";
import { Button } from "~/atoms/button";

export type ActiveFilterChip = {
  key: string;
  label: string;
  comparatorLabel: string;
  value: string;
  onRemove: () => void;
};

interface ActiveFilterChipsProps {
  items: ActiveFilterChip[];
}

export const ActiveFilterChips = ({ items }: ActiveFilterChipsProps) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      {items.map((filterItem) => (
        <div
          key={filterItem.key}
          className="border-border bg-card text-card-foreground flex gap-1 rounded-md border px-1 text-sm font-normal"
        >
          <span className="p-1">{filterItem.label}</span>

          <span className="text-primary-foreground bg-primary/80 px-2 py-1">
            {filterItem.comparatorLabel}
          </span>
          <span className="p-1">{filterItem.value}</span>
          <Button variant="ghost" size="icon-sm" onClick={filterItem.onRemove}>
            <X />
          </Button>
        </div>
      ))}
    </div>
  );
};
